module.exports = __webpack_public_path__ + "img/mine-avatar.75a983f6.png";